import styled from "styled-components"
import arrIcon from "../../../images/svg/jobList/arr4.svg"
import { useDispatch } from "react-redux"
import { handleFrameState } from "../../../features/joblist/jobListSlice"
import useWindowDimensions from "../../../hooks/useWindowSize"

const Container = styled.div`
    width: 100%;
    height: 50vh;
    border-radius: 10px;
    border: 3px solid ${({theme}) => theme.mainBorderColor};
    position: sticky;
    right: left;
    top: 250px;
    margin-top: 30px;

    cursor: pointer;

    .wrapper{
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-size: var(--font-size-md);
        font-weight: var(--font-weight-lg);
        @media (max-height: 800px){
            font-size: var(--font-size-sm);
        }

        .space{
            padding: 10px 0;
            @media (max-height: 800px){
                padding: 5px 0;
            }
        }

        img{
            position: absolute;
            top: 0;
            left: 0;
        }
    }


`

const YukColumnBtn = () => {

  const textArr = "Araç Bekleyen Yükler".split("")
  const dispatch = useDispatch()

  const {windowDimensions} = useWindowDimensions()

    const changeFrame = () => {
        if(windowDimensions?.width < 1500){
            dispatch(handleFrameState("yukSide"))
        }else{
            dispatch(handleFrameState("equal"))
        }
    }

  return (
    <Container onClick={changeFrame}>
        <div className="wrapper">
            {
                textArr.map(item => (
                  <div className={item === " " ? "letter-item space" : "letter-item"}>{item}</div>
                ))
            }
            <img src={arrIcon} alt="" />
        </div>
    </Container>
  )
}

export default YukColumnBtn